import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-marketing-request',
  templateUrl: './marketing-request.component.html',
  styleUrl: './marketing-request.component.scss',
})
export class MarketingRequestComponent {
  @Output() navigateToAllocation = new EventEmitter<void>();

  openAllocationTab(): void {
    this.navigateToAllocation.emit();
  }
}
